module.exports = __webpack_public_path__ + "media/images/flags/16/Panama-ef22e2554079cfa8c8265565c7747879.png";